module.exports = __webpack_public_path__ + "static/media/c-pop-up-4.bde07829.png";